import { HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SITE_CONTEXT } from '@app/core/site-context';

@Injectable({ providedIn: 'root' })
export class TenantService {
  private readonly ctx = inject(SITE_CONTEXT);
  private isLiveMode = false;

  /** Backwards-compat method name. Returns the host. */
  getTenant(): string {
    return this.ctx.host;
  }

  /** No-op kept for backwards compatibility with existing callers. */
  setTentant(_x_tenant_id: string): void {
    // intentional no-op: tenant is now resolved at the edge, not set by clients
  }

  addLiveToHeaders(headers: HttpHeaders): HttpHeaders {
    return headers.append('Live', 'true');
  }

  setLiveMode(isLive: boolean): void {
    this.isLiveMode = isLive;
  }

  getLiveMode(): boolean {
    return this.isLiveMode;
  }
}
